"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _requestEntity = require("settings-ui-sdk/requestEntity");

var _LaboratoryActions = require("./LaboratoryActions");

var intialState = (0, _immutable.Map)(); // Example State: (where objects are immutable maps)
// laboratory: {
//   'strat-dub-mailchimp': {
//     group: {
//       key: 'group',
//       value: 'variant',
//       isAssigned: true
//     }
//   }
// }

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : intialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _LaboratoryActions.FetchTreatmentActionType.SUCCESS:
      {
        var data = (0, _requestEntity.getPayloadData)(action);
        var result = data.parameters.reduce(function (acc, item) {
          return acc.setIn([data.key, item.key], (0, _immutable.Map)(item));
        }, (0, _immutable.Map)((0, _defineProperty2.default)({}, data.key, (0, _immutable.Map)())));
        return state.merge(result);
      }

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;